import { Component, computed, input } from '@angular/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';

@Component({
  selector: 'meeting-analysis-score-badge',
  template: ` <glxy-badge [color]="scorePercentage() > 70 ? 'green' : scorePercentage() > 50 ? 'yellow' : 'red'"
    >{{ score() + ' / ' + maxScore() }}
  </glxy-badge>`,
  imports: [GalaxyBadgeModule],
})
export class ScoreBadgeComponent {
  score = input<number>(0);
  maxScore = input<number>(25);

  scorePercentage = computed(() => {
    return (this.score() / this.maxScore()) * 100;
  });
}
